module.exports = __webpack_public_path__ + "img/13.aee14b34.png";